import { useEffect, useState } from 'react';
import { ENV_CONFIG } from 'config/environment';
import { convertUrlToFile } from 'views/Pages/utils';
import { SetsData } from 'store/sets/types';

type Props = {
  isPageDuplicated: boolean;
  editSetPageSelected: SetsData | undefined;
  form: any;
};

export const DuplicateMediaLoader = ({ isPageDuplicated, editSetPageSelected, form }: Props) => {
  const [hasLoadedMedia, setHasLoadedMedia] = useState(false);

  useEffect(() => {
    if (!isPageDuplicated || !editSetPageSelected || hasLoadedMedia) return;

    const loadMedia = async () => {
      const misc = editSetPageSelected.set_misc;
      if (!misc) return;

      const oldQueryString = editSetPageSelected.querystring;
      if (!oldQueryString) return;

      const gcsBase = `${ENV_CONFIG().CLOUD_STORAGE.URL}/${ENV_CONFIG().CLOUD_STORAGE.SETS}`;
      const imageFilenames = editSetPageSelected.image_filenames;

      if (misc.has_header_video) {
        const filename = imageFilenames?.header_video;
        const videoUrl = filename
          ? `${gcsBase}/${filename}`
          : `${gcsBase}/${oldQueryString}/header.mp4`;
        const videoFile = await convertUrlToFile(videoUrl, filename ?? 'header.mp4');
        if (videoFile) {
          form.change('setVideoFile', videoFile);
        }
      }

      if (misc.has_header_logo) {
        const filename = imageFilenames?.header_logo;
        const logoUrl = filename
          ? `${gcsBase}/${filename}`
          : `${gcsBase}/${oldQueryString}/set-logo.png`;
        const logoFile = await convertUrlToFile(logoUrl, filename ?? 'set-logo.png');
        if (logoFile) {
          form.change('setLogoFile', logoFile);
        }
      }

      const sections = misc.sections || [];

      await Promise.all(
        sections.map(async (section: any, index: number) => {
          if (!section?.has_image || !section?.id) return;
          const filename = imageFilenames?.[`section:${section.id}`];
          const sectionUrl = filename
            ? `${gcsBase}/${filename}`
            : `${gcsBase}/${oldQueryString}/section-${section.id}-logo.png`;
          const sectionFile = await convertUrlToFile(
            sectionUrl,
            filename ?? `section-${section.id}-logo.png`
          );
          if (sectionFile) {
            form.change(`sections.${index}.image_file`, sectionFile);
          }
        })
      );

      setHasLoadedMedia(true);
    };

    void loadMedia();
  }, [isPageDuplicated, editSetPageSelected, form, hasLoadedMedia]);

  return null;
};
